import React from "react";

const DoNotSell = () => (
  <main style={{ padding: "2rem", maxWidth: 800, margin: "0 auto" }}>
    <h1>Do Not Sell My Personal Information</h1>
    <p>At S. Huntley &amp; Co., we value your privacy. We do not sell your personal information to third parties.</p>
    <p>If you are a California resident, the California Consumer Privacy Act (CCPA) gives you the right to request:</p>
    <ul>
      <li>Disclosure of personal data we have collected</li>
      <li>Deletion of your personal data</li>
      <li>Confirmation that we do not sell your data</li>
    </ul>
    <p>If you would like to make a request under CCPA, please email us at:</p>
    <p><span role="img" aria-label="email">📧</span> <a href="mailto:dwhitlock@shuntley.co">dwhitlock@shuntley.co</a></p>
  </main>
);

export default DoNotSell;
